// extracted by mini-css-extract-plugin
module.exports = {"button":"GladChat_button__uXdb_"};